/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/
import { CSSProperties } from "react";

export class StyleManager {

  private static _stylesheet: HTMLStyleElement;
  private static _styles: { [id: string]: CSSProperties } = {};

  private static get stylesheet(): HTMLStyleElement {
    if (!this._stylesheet) {
      this._stylesheet = document.createElement('style');
      document.getElementsByTagName('head')[0].appendChild(this._stylesheet);
    }
    return this._stylesheet;
  }

  private static _serializeStyle(selector: string, style: CSSProperties): string {
    const stringified = Object.entries(style).map(([k, v]) => `${k}:${v}`).join(';\n').replace(/[A-Z]/g, match => `-${match.toLowerCase()}`);
    return `${selector} {${stringified}}`
  }

  private static _generateStylesheet(): void {
    const generated: string[] = [];

    for (const key in this._styles) {
      if (Object.prototype.hasOwnProperty.call(this._styles, key)) {
        const element = this._styles[key];
        generated.push(this._serializeStyle(key, element))
      }
    }

    this.stylesheet.innerHTML = generated.join("\n");
  }

  public static createCSSSelector(selector: string, style: CSSProperties): void {
    if (!this._styles[selector]) {
      this._styles[selector] = style;
    } else {
      this._styles[selector] = { ...this._styles[selector], ...style };
    }
    this._generateStylesheet();
  }

}